import colors from '@/config/colors';
import { isPatientApp } from '@/config/constants';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 32,
  },

  itemContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    paddingHorizontal: isPatientApp ? 0 : 20,
  },

  label: { fontWeight: 600 },

  divider: {
    width: '100%',
    height: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    marginVertical: 20,
  },

  longLabelContainer: { maxWidth: '70%', gap: 8 },

  mailWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    height: 52,
  },

  leftBorder: {
    width: 2,
    backgroundColor: colors.newUI.therapist.textBlue100,
    marginRight: 12,
  },

  modalFooter: { flexDirection: 'row', justifyContent: 'flex-end', gap: 16 },
});
